export const ORG_PREFERENCES = {
	ORG_ONBOARDING: 'org_onboarding',
};
